import React, { useState } from 'react';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { styled } from '@mui/system';
import { SFPalette } from '@/lib/color';

const HEIGHT = 24;
const WIDTH = 48;

const SFSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName="focus-visible" disableRipple {...props} />
))({
  width: WIDTH,
  height: HEIGHT,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: `translateX(${WIDTH / 2}px)`,
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: SFPalette.shuffleColor,
        opacity: 1,
        border: 'none',
      },
      '&.focus-visible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&::before': {
        display: 'none',
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 20,
      height: 20,
      boxShadow: 'none',
    },
    '& + .MuiSwitch-track': {
      borderRadius: HEIGHT / 2,
      backgroundColor: SFPalette.lightGrey2,
      opacity: 1,
      transition: '300ms',
    },
  },
});

export default SFSwitch;
